import { Cancel, Search } from "@mui/icons-material"
import { InputAdornment, TextField, Tooltip } from "@mui/material"
import { QuickFilterClear, QuickFilterControl, QuickFilterTrigger, ToolbarButton, QuickFilter as ToolbarQuickFilter } from "@mui/x-data-grid-premium"

import "./quick-filter.scss"

export default function QuickFilter() {
  return (
    <ToolbarQuickFilter className="quick-filter">
      <QuickFilterTrigger
        render={(triggerProps, state) => (
          <Tooltip title="Search">
            <ToolbarButton
              {...triggerProps}
              className="quick-filter__trigger"
              data-expanded={state.expanded}
            >
              <Search fontSize="small" />
            </ToolbarButton>
          </Tooltip>
        )}
      />
      <QuickFilterControl
        render={({ ref, ...controlProps }, state) => (
          <TextField
            {...controlProps}
            inputRef={ref}
            aria-label="Search"
            placeholder="Search..."
            size="small"
            className="quick-filter__control"
            data-expanded={state.expanded}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Search fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: state.value ? (
                  <InputAdornment position="end">
                    <QuickFilterClear
                      edge="end"
                      size="small"
                      aria-label="Clear search"
                      className="quick-filter__clear"
                    >
                      <Cancel fontSize="small" />
                    </QuickFilterClear>
                  </InputAdornment>
                ) : null,
                ...controlProps.slotProps?.input,
              },
              ...controlProps.slotProps,
            }}
          />
        )}
      />
    </ToolbarQuickFilter>
  )
}
